export default "__VITE_ASSET__I$7QC_kz__"